import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLinkWithHref } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ModalComponent } from '../../components/modal/modal.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { UniversityService } from '../../services/university.service';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { ButtonComponent } from '../../components/button/button.component';
import { ExamService } from '../../services/exam.service';
import { FormsModule } from '@angular/forms';
import { PaymentService } from '../../services/payment.service';
import { EvaluationService } from '../../services/evaluation.service';

@Component({
  selector: 'app-student-portal-list-page',
  imports: [HeaderComponent, CommonModule, ModalComponent, PluralPipe, AgGridListComponent, SelectInputComponent, SearchInputComponent, ButtonComponent, RouterLinkWithHref, FormsModule],
  templateUrl: './student-portal-list-page.component.html',
})
export class StudentPortalListPageComponent {
  @ViewChild('re_evaluate_modal') re_evaluate_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  page_name = 'Exam Results';
  params: any = {};
  selected_item: any = {}
  items: any = [];

  city_cols: any = [
    { field: 'subject.name', headerName: 'Subject Name', filter: true, minWidth: 150, flex: 1, valueGetter: (params: any) => params.data?.subject?.name || '-' },
    { field: 'subject.code', headerName: 'Subject Code', filter: true, minWidth: 120, flex: 1, valueGetter: (params: any) => params.data?.subject?.code || '-' },
    { field: 'exam.name', headerName: 'Exam Name', filter: true, minWidth: 150, flex: 1, valueGetter: (params: any) => params.data?.exam?.name || '-' },
    { field: 'total_marks', headerName: 'Total Marks', filter: true, minWidth: 120, flex: 1 },
    { field: 'marks_obtained', headerName: 'Marks Obtained', filter: true, minWidth: 120, flex: 1, cellRenderer: (params: any) => { const marks = params.data?.marks_obtained; return marks !== null && marks !== undefined ? marks : 'N/A'; } },
    { field: 'result', headerName: 'Result', filter: true, minWidth: 100, flex: 1, cellRenderer: (params: any) => { const marks = params.data?.marks_obtained; const passing = params.data?.passing_marks; if (marks === null || marks === undefined) return 'Pending'; const isPassed = marks >= passing; return `<span style="color: ${isPassed ? 'green' : 'red'}; font-weight: bold;">${isPassed ? 'Pass' : 'Fail'}</span>`; } },
    { field: 'released_date', headerName: 'Released Date', filter: true, minWidth: 130, flex: 1 },
    { headerName: "Actions", sortable: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 210, minWidth: 210, maxWidth: 210 },
  ];

  re_evaluation_reasons = [
    { title: 'Marks not as expected', value: 'Marks not as expected' },
    { title: 'Subjective answers need recheck', value: 'Subjective answers need recheck' },
    { title: 'Not Satisfied with Evaluation', value: 'Not Satisfied with Evaluation' },
    { title: 'Incorrect Calculation ', value: 'Incorrect Calculation ' },
    { title: 'All Questions not Evaluated', value: 'All Questions not Evaluated' }
  ];
  re_evaluation_reason: string = '';

  actions(row: any) {
    let actions: any = []
    actions.push({ type: 'button', text: 'Re-Evaluate', function: this.re_evaluate_modal_open.bind(this) })
    actions.push({ type: 'icon-filled', icon: 'bx bx-eye', function: this.open_view_modal.bind(this) })
    return actions
  }

  constructor(public gs: GlobalService, public route: Router, public us: UniversityService, public ar: ActivatedRoute, public es: ExamService, public ps: PaymentService, public evs: EvaluationService) { }

  async ngOnInit() {
    this.ar.queryParams.subscribe(async (params: any) => { this.params = { ...params } })
  }

  async get_list(filter?: any) {
    try {
      filter = { ...filter, release_status: 'released' }
      const res = await this.es.get_exam_result_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;
      res.data = res.data.map((item: any, index: number) => ({ ...item, SrNo: startindex + index + 1, result_status: item.marks_obtained !== null && item.marks_obtained !== undefined ? (item.marks_obtained >= item.passing_marks ? 'Pass' : 'Fail') : 'Pending' }));
      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Result list:", error);
    }
  }

  async open_view_modal(item: any, index: any) {
    this.selected_item = item;
    window.open('https://ugcnetonline.in/14_J_OMR_I_&_II.pdf', '_blank');
  }

  async re_evaluate_modal_open(item: any, index: any) {
    this.selected_item = item;
    this.re_evaluate_modal?.open();
  }

  async payment() {
    try {
      const paymentResponse = await this.ps.make_payment({ script_id: this.selected_item.script_id });
      if (paymentResponse.code === 200 && paymentResponse.data.payment_status === 'success') {
        const reEvalResponse = await this.evs.request_re_evaluation({ script_id: this.selected_item.script_id, reason: this.re_evaluation_reason });
        if (reEvalResponse.code === 200) {
          this.gs.toastr_shows_function(`Re-evaluation request submitted successfully! Request ID: ${reEvalResponse.data.request_id}`, 'Success', 'success');
        }
      }
      this.re_evaluate_modal?.close();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.message || 'Payment or re-evaluation failed', 'Error', 'error');
    }
  }
}
